import { motion } from "framer-motion";
import { scrollToId } from "@/lib/lenisScroll";
import { STORE } from "../../data/site";

export const Nav = () => {
  const go = (id) => (id === 0 ? scrollToId("body", { offset: 0 }) : scrollToId(id));

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 left-0 z-50 w-full"
      data-testid="site-nav"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-6 md:px-10">
        <button
          onClick={() => go(0)}
          className="flex items-center text-white transition-opacity hover:opacity-80"
          data-testid="nav-logo"
        >
          <span className="font-display text-lg font-medium tracking-[0.3em]">
            RADIATE
          </span>
        </button>

        <nav className="hidden items-center gap-9 md:flex">
          {[
            ["The method", "#method"],
            ["Free meditation", "#meditation"],
            ["The app", "#app"],
            ["Reviews", "#reviews"],
          ].map(([label, id]) => (
            <button
              key={id}
              onClick={() => go(id)}
              className="text-sm text-white/60 transition-colors hover:text-white"
              data-testid={`nav-link-${id.slice(1)}`}
            >
              {label}
            </button>
          ))}
        </nav>

        <a
          href={STORE.appStore}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-full bg-white px-5 py-2.5 text-sm font-medium text-black transition-transform duration-300 hover:scale-105 hover:shadow-[0_0_24px_rgba(255,255,255,0.35)]"
          data-testid="nav-download-btn"
        >
          Download free
        </a>
      </div>
    </motion.header>
  );
};
